import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Pay with Credit Card", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolActivationForm = _resolveComponent("SchoolActivationForm")!
  const _component_SchoolActivationConfirm = _resolveComponent("SchoolActivationConfirm")!
  const _component_SagePay = _resolveComponent("SagePay")!
  const _component_UserArea = _resolveComponent("UserArea")!

  return (_openBlock(), _createBlock(_component_UserArea, {
    "user-types": ['schoolAdmin'],
    "admin-can-always-see": true,
    class: "sf-container"
  }, {
    default: _withCtx(() => [
      (_ctx.school)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.step == 'activate')
              ? (_openBlock(), _createBlock(_component_SchoolActivationForm, {
                  key: 0,
                  mode: _ctx.mode,
                  "default-data": _ctx.currentPurchase,
                  onSuccess: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.refreshPuchase($event);
          _ctx.setStep('confirm');
        })
                }, null, 8, ["mode", "default-data"]))
              : (_ctx.step == 'confirm')
                ? (_openBlock(), _createBlock(_component_SchoolActivationConfirm, {
                    key: 1,
                    mode: _ctx.mode,
                    tax: _ctx.tax,
                    "school-reference": _ctx.schoolReference,
                    "activate-trial": _ctx.activateTrial,
                    "purchase-data": _ctx.purchaseData,
                    onModify: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStep('activate'))),
                    onPaywithcard: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStep('payWithCard')))
                  }, null, 8, ["mode", "tax", "school-reference", "activate-trial", "purchase-data"]))
                : (_ctx.step == 'payWithCard')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _hoisted_3,
                      (_ctx.purchaseData)
                        ? (_openBlock(), _createBlock(_component_SagePay, {
                            key: 0,
                            mode: _ctx.mode,
                            "school-reference": _ctx.schoolReference,
                            "purchase-data": _ctx.purchaseData,
                            onModify: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStep('activate')))
                          }, null, 8, ["mode", "school-reference", "purchase-data"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}